export const replyToCopy = {
  title: '',
  description: '',
  label: '',
  placeholder: '',
};
